var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#800DF2","key":0}),React.createElement("path",{"d":"M10.6525 10.4975C11.6595 10.4975 12.4758 9.68116 12.4758 8.67416C12.4758 7.66716 11.6595 6.85083 10.6525 6.85083C9.6455 6.85083 8.82916 7.66716 8.82916 8.67416C8.82916 9.68116 9.6455 10.4975 10.6525 10.4975Z","fill":"white","key":1}),React.createElement("path",{"d":"M14.1975 11.8792V21.995H17.3383V16.9925C17.3383 15.6725 17.5867 14.3942 19.2233 14.3942C20.8375 14.3942 20.8575 15.9033 20.8575 17.0758V21.9958H24V16.4483C24 13.7233 23.4133 11.6292 20.2283 11.6292C18.6992 11.6292 17.6742 12.4683 17.255 13.2625H17.2125V11.8792H14.1975ZM9.07916 11.8792H12.225V21.995H9.07916V11.8792Z","fill":"white","key":2})]);
}

Linkedin.defaultProps = {"width":"44","height":"44","viewBox":"0 0 32 32","fill":"none"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
